const makeInitialState = (data, quoteInformation) => ({
  ...data,
  term: data.term || '',
  enableMsi: data.enableMsi || false,
  phone: quoteInformation?.phone || '',
  email: quoteInformation?.email || '',
  client: quoteInformation?.clientName || '',
  equipmentName: quoteInformation?.equipmentName || '',
  distributorName: quoteInformation?.distributorName || ''
});

export default makeInitialState;
